import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Cart, CartSolid } from '@core-ds/icons/24';
import Dropdown from './dropdown';

const Container = styled.div`
   width: 350px;
   text-align: left;
`;

const CartIcon = styled(Cart)`
   color: ${color.gray4};
`;

const CartSolidIcon = styled(CartSolid)`
   color: ${color.gray1};
`;

const mapStateToProps = state => ({
   miniCartHtml: state.headerState.miniCart.html,
   numProducts: state.headerState.miniCart.numProducts,
});

const MiniCartDropdown = ({ cartUrl, miniCartHtml, numProducts }) => {
   const hideMiniCart = () => {
      window.location = cartUrl;
   };

   const simpleMiniCart = !miniCartHtml;

   return (
      <Dropdown
         id="miniCart"
         icon={
            numProducts ? (
               <CartSolidIcon aria-label="my cart" id="miniCartDropdownToggle" focusable="false" />
            ) : (
               <CartIcon aria-label="my cart" id="miniCartDropdownToggle" focusable="false" />
            )
         }
         hasBadge={numProducts != 0}
         wait={simpleMiniCart && hideMiniCart}
      >
         <Container
            id={simpleMiniCart ? 'hydra-mini-cart-simple' : ''}
            dangerouslySetInnerHTML={{ __html: miniCartHtml }}
         />
      </Dropdown>
   );
};

export default connect(mapStateToProps)(MiniCartDropdown);
